import TenderPayouts from './TenderPayouts';

export default TenderPayouts;
